export function Spliter() {
  return (
    <div className="w-full h-px my-2 bg-gray-300 dark:bg-gray-600"></div>
  );
}
